import { ITest } from "../../interface/IConfig";
import { DATA_INIT } from "../../interface/TStatus";

const tests: ITest[] = [
  {
    request: {
    httpMethod: "POST",
    queryStringParameters: {
        condition: {
            id: "###team1###"
          }
    },
    headers: {
        "Content-Type": "application/json; charset=utf8",
        "Accept-Encoding": "gzip, deflate, sdch",
        "Accept-Language": "en-US,en;q=0.8",
        Origin: "http://unit-test.at",
        "x-api-key": "###apiKey###",
        Cookie: "###session###",
      },
      body: {
        id: "###team1###"
      },
        path:  "/idp/team/leave",
    },
    response: {
      statusCode: 400,
      headers: { 
        "Access-Control-Allow-Headers": "Content-Type, X-Amz-Date, Authorization, X-Api-Key, X-Amz-Security-Token, X-Amz-User-Agent",
        "Access-Control-Allow-Origin": "http://unit-test.at",
        "Access-Control-Request-Method": "OPTIONS, POST, GET, PATCH, PUT, DELETE",
        "content-length": "162",
        "content-type": "application/json"
      },
      body: {
        error: "BAD_REQUEST",
        errors: {
          "headers.cookie.Authorization": "isOwner"
        },
        message: "You can not leave a team if you are the owner. Howerver you can delete it."
      },
    },
    status: DATA_INIT,
  },
];

export default tests;